var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"decrypt-img"},[(_vm.decryptBlob)?_c('img-load',_vm._b({staticClass:"decrypt-img",attrs:{"src":_vm.decryptBlob,"fit":"contain"},on:{"load":_vm.onImgLoad}},'img-load',_vm.$attrs,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }